import AsyncSelect from "react-select/async";
import "../../styles/select.css";

const AsyncSpotSelect = props => {
  return (
    <div className="spot-select">
      <AsyncSelect
        cacheOptions
        unstyled
        loadOptions={props.loadOptions}
        onInputChange={props.onInputChange}
        onChange={props.onChange}
        className="spot-select-container"
        classNamePrefix="spot-select"
        {...props}
      />
    </div>
  );
};

export default AsyncSpotSelect;
